import { SessionService } from '@/app/core/services/session.service';
import { HttpParams } from '@angular/common/http';
import {
  Component,
  effect,
  inject,
  input,
  output,
  signal,
} from '@angular/core';

@Component({
  selector: 'c-verify-twofa',
  standalone: false,
  templateUrl: './verify-twofa.component.html',
  styleUrl: './verify-twofa.component.css',
})
export class VerifyTwofaComponent {
  // private sessionService = inject(SessionService);

  // requestCode = input<boolean>();
  // constructor() {
  //   effect(() => {
  //     if (this.requestCode()) this.sendCodeRequest();
  //   });
  // }

  // code = signal('');
  // loading = signal(false);
  // error = signal('');

  // verify(): void {
  //   if (this.code().length !== 6 || this.loading()) {
  //     return;
  //   }

  //   this.loading.set(true);
  //   this.error.set('');

  //   this.verifyCode(this.code());
  // }

  // private verifyCode(code: string) {
  //   this.sessionService.twoFAVerify(code).subscribe({
  //     next: (data) => {
  //       // Verificamos un código activo
  //       this.verificationResult(data?.verified);
  //     },
  //     error: (err) => {
  //       console.error(err);
  //       this.verificationResult(false);
  //     },
  //   });
  // }

  // onVerificationResult = output<boolean>();

  // private verificationResult(valid: boolean, initial = false): void {
  //   this.loading.set(false);

  //   if (!valid) {
  //     this.onVerificationResult.emit(false);

  //     if (!initial) this.error.set('El código es incorrecto o ha expirado.');
  //     return;
  //   }

  //   this.onVerificationResult.emit(true);
  //   this.code.set('');
  // }

  // onCodeChange(value: string): void {
  //   this.code.set(value.replace(/\D/g, '').slice(0, 6));
  //   this.error.set('');
  // }

  // resendCode = output<void>();
  // resendVerificationCode(): void {
  //   if (this.loading()) {
  //     return;
  //   }

  //   this.error.set('');
  //   this.resendCode.emit();
  // }

  // private sendCodeRequest() {
  //   this.sessionService.twoFAStatus().subscribe({
  //     next: (data) => {
  //       // Verificamos si no estaba ya con un código activo
  //       this.verificationResult(data?.verified, true);
  //     },
  //     error: (err) => {
  //       console.error(err);
  //     },
  //   });
  // }

  private sessionService = inject(SessionService);

  requestCode = input<boolean>(false);

  code = signal('');
  loading = signal(false);
  error = signal('');

  onVerificationResult = output<boolean>();
  resendCode = output<void>();

  constructor() {
    effect(() => {
      if (this.requestCode()) {
        this.checkCodeStatus();
      }
    });
  }

  private checkCodeStatus(): void {
    this.loading.set(true);
    this.error.set('');

    const params = new HttpParams().set('force', 'false');

    this.sessionService.checkTwoFAStatus(params).subscribe({
      next: (data) => {
        this.loading.set(false);

        if (data?.verified) {
          this.onVerificationResult.emit(true);
        }
      },
      error: (err) => {
        console.error(err);
        this.loading.set(false);
        this.error.set('No se pudo comprobar el estado del código.');
      },
    });
  }

  verify(): void {
    if (this.code().length !== 6 || this.loading()) {
      return;
    }

    this.loading.set(true);
    this.error.set('');

    this.sessionService.twoFAVerify(this.code()).subscribe({
      next: (data) => {
        this.loading.set(false);

        if (data?.verified) {
          this.code.set('');
          this.onVerificationResult.emit(true);
        } else {
          this.error.set('El código es incorrecto o ha expirado.');
        }
      },
      error: (err) => {
        console.error(err);
        this.loading.set(false);
        this.error.set('El código es incorrecto o ha expirado.');
      },
    });
  }

  onCodeChange(value: string): void {
    this.code.set(value.replace(/\D/g, '').slice(0, 6));
    this.error.set('');
  }

  resendVerificationCode(): void {
    if (this.loading()) {
      return;
    }

    this.error.set('');

    const params = new HttpParams().set('force', 'true');
    this.sessionService.checkTwoFAStatus(params, true).subscribe({
      next: (data) => {
        this.loading.set(false);

        this.onVerificationResult.emit(data.verified);
      },
      error: (err) => {
        console.error(err);
        this.loading.set(false);
        this.error.set('No se pudo comprobar el estado del código.');
      },
    });
  }
}
